import { render, staticRenderFns } from "./CorrelationWeightSetup.vue?vue&type=template&id=26a1ef47&"
import script from "./CorrelationWeightSetup.vue?vue&type=script&lang=js&"
export * from "./CorrelationWeightSetup.vue?vue&type=script&lang=js&"
import style0 from "./CorrelationWeightSetup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports